(function () {
  function getSettings() {
    var el = document.getElementById('lenz-delivery-data');
    if (!el) return null;

    var zones = [];
    el.querySelectorAll('.lenz-delivery-zone').forEach(function (z) {
      zones.push({ label: z.dataset.label, price: z.dataset.price });
    });

    var termsRaw = el.dataset.terms || '';
    var tmp = document.createElement('div');
    tmp.innerHTML = termsRaw;
    var terms = tmp.innerHTML.split(/<br\s*\/?>/i).map(function (t) {
      return t.replace(/<[^>]+>/g, '').trim();
    }).filter(Boolean);

    return {
      title: el.dataset.title || 'Delivery Charges',
      btnLabel: el.dataset.btnLabel || 'Delivery Charges',
      zones: zones,
      terms: terms
    };
  }

  function buildModal(cfg) {
    var overlay = document.createElement('div');
    overlay.id = 'lenz-delivery-modal';
    overlay.className = 'lenz-delivery-modal-overlay';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) overlay.classList.remove('active');
    });

    var rows = cfg.zones.map(function (r) {
      return '<tr><td>' + r.label + '</td><td>' + r.price + '</td></tr>';
    }).join('');

    var terms = cfg.terms.map(function (t) { return '<li>' + t + '</li>'; }).join('');

    overlay.innerHTML =
      '<div class="lenz-delivery-modal">' +
        '<button class="lenz-delivery-close" id="lenz-delivery-close" type="button">&times;</button>' +
        '<h3><span class="lenz-truck-icon">&#128666;</span> ' + cfg.title + '</h3>' +
        '<table class="lenz-delivery-table">' +
          '<thead><tr><th>Distance</th><th style="text-align:right">Charge</th></tr></thead>' +
          '<tbody>' + rows + '</tbody>' +
        '</table>' +
        (terms ? '<div class="lenz-delivery-terms"><strong>&#9888; Important Terms</strong><ul>' + terms + '</ul></div>' : '') +
      '</div>';

    document.body.appendChild(overlay);

    document.getElementById('lenz-delivery-close').addEventListener('click', function () {
      overlay.classList.remove('active');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') overlay.classList.remove('active');
    });
  }

  function buildTrigger(cfg) {
    var wrap = document.createElement('div');
    wrap.className = 'lenz-delivery-wrap';
    wrap.innerHTML =
      '<button class="lenz-delivery-trigger" id="lenz-delivery-trigger" type="button">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
        ' ' + cfg.btnLabel + ' ' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
      '</button>';
    return wrap;
  }

  function inject() {
    if (document.getElementById('lenz-delivery-modal')) return;
    var cfg = getSettings();
    if (!cfg || cfg.zones.length === 0) return;

    buildModal(cfg);

    var trigger = buildTrigger(cfg);
    var anchor =
      document.querySelector('.product-form__buttons') ||
      document.querySelector('product-info .price') ||
      document.querySelector('.product-form');

    if (anchor) {
      anchor.parentNode.insertBefore(trigger, anchor.nextSibling);
    }

    document.getElementById('lenz-delivery-trigger').addEventListener('click', function () {
      document.getElementById('lenz-delivery-modal').classList.add('active');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
